import { Base } from '@gate31/core/src/libs/BaseComponent';
import { Loyalty } from '@gate31/feature/Loyalty/Loyalty';
import { LoyaltyCupon } from '@gate31/feature/Loyalty/LoyaltyCupon';

import { CartLoyaltyBonuses } from '@gate31/feature/Loyalty/LoyaltyBonuses';

export class CartLoyaltyBonusesDesk extends CartLoyaltyBonuses {
    static cn = new Base.BuildCn('CartLoyaltyDesk');

    constructor(node: HTMLElement) {
        super({
            node,
            cn: CartLoyaltyBonusesDesk.cn
        });
    }
}

export class CartLoyaltyCuponDesk extends LoyaltyCupon {
    static cn = new Base.BuildCn('CartLoyaltyDesk');

    constructor(node: HTMLElement) {
        super({
            node,
            cn: CartLoyaltyCuponDesk.cn
        });
    }
}

export class CartLoyaltyDesk extends Loyalty {
    static cn = new Base.BuildCn('CartLoyaltyDesk');

    constructor(node: HTMLElement) {
        super({
            node,
            cn: CartLoyaltyDesk.cn,
            bonuses: new CartLoyaltyBonusesDesk(CartLoyaltyBonusesDesk.querySelector(CartLoyaltyBonusesDesk.cn.toSelector())),
            cupon: new CartLoyaltyCuponDesk(CartLoyaltyCuponDesk.querySelector(CartLoyaltyCuponDesk.cn.toSelector()))
        });
    }
}

